import React from "react";
import { css } from "@emotion/react";

interface IProps extends React.AllHTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

export const CardColumn: React.FC<IProps> = (
  props: IProps
): React.ReactElement<IProps> => {
  const { children, ...rest } = props;
  return (
    <div css={cardColumnStyle} {...rest}>
      {children}
    </div>
  );
};

const cardColumnStyle = css`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;
